/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";
import {
  Button,
  Flex,
  Group,
  Modal,
  Select,
  Text,
  TextInput,
  Textarea,
} from "@mantine/core";
import { GraphQLQuery, generateClient } from "aws-amplify/api";
import { TEMPLATE_SECTION_FIELD_PLACEHOLDER } from "@/utils/constants";
import { appShowNotification } from "@/utils/utils";
import { createTemplateField } from "@/graphql/mutations";
import {
  CreateTemplateFieldInput,
  CreateTemplateFieldMutation,
  CreateTemplateFieldMutationVariables,
} from "@/API";

const client = generateClient();

type addNewSectionTemplateProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  template: any;
  fetchTemplate: (templateId: string) => void;
};

const AddFieldTemplateModal = (props: addNewSectionTemplateProps) => {
  const { modalOpened, setModalOpened, fetchTemplate, template } = props;
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sections, setSections] = useState();
  const [sectionId, setSectionId] = useState<any>();
  const [subSections, setSubsections] = useState<any>();
  const [subSectionId, setSubSectionId] = useState<any>();
  const [fieldName, setFieldName] = useState("");
  const [fieldValue, setFieldValue] = useState("");
  const defaultValueRef = useRef(null);

  const handleInsertInput = async () => {
    const inputMaster = "#INPUT#";
    const textarea: any = defaultValueRef.current;
    const { selectionStart, selectionEnd }: any = textarea;
    const newText =
      fieldValue.substring(0, selectionStart) +
      inputMaster +
      fieldValue.substring(selectionEnd);
    setFieldValue(newText);
    textarea.focus();
  };

  useEffect(() => {
    if (!template?.sections) {
      return;
    }
    const initSections = template.sections.items
      .filter(
        (section: any) =>
          (section.isSimple === false || section.isSimple === null) &&
          section?.subsections?.items.length > 0 &&
          section.name,
      )
      ?.map((section: any) => {
        return { value: section.id, label: section.name };
      });

    if (initSections && initSections.length > 0) {
      setSections(initSections);
      setSectionId(initSections[0].value);
    }
  }, [template, modalOpened]);

  useEffect(() => {
    if (!sections && modalOpened) {
      closeAndResetModal();
      appShowNotification({
        title: "Please create subsection first!",
        type: "warning",
      });
    }
  }, [modalOpened]);

  useEffect(() => {
    if (!template?.sections || !sectionId) {
      return;
    }
    const sectionDetail = template?.sections?.items.find(
      (section: any) => section.id == sectionId,
    );
    const lstSubsection = sectionDetail?.subsections?.items
      ?.filter((subsection: any) => subsection.name)
      .map((subs: any) => {
        return { value: subs.id, label: subs.name };
      });

    if (lstSubsection && lstSubsection.length > 0) {
      setSubSectionId(lstSubsection[0]?.value);
      setSubsections(lstSubsection);
    } else {
      setSubSectionId("");
      setSubsections(null);
    }
  }, [sectionId, modalOpened]);

  const handleAddField = async () => {
    if (
      fieldName === "" ||
      fieldValue === "" ||
      sectionId === "" ||
      subSectionId === ""
    ) {
      setErrorMsg(
        "Please provide a name, default value, section, and subsection",
      );
      return;
    }
    setErrorMsg("");
    setIsLoading(true);
    try {
      try {
        // dispatch(setIsRefreshing());
        // Use your GraphQL client to make a mutation call
        const createFieldInput: CreateTemplateFieldInput = {
          name: fieldName,
          value: fieldValue,
          ssID: subSectionId,
          tID: template.id,
        };
        const createFieldVars: CreateTemplateFieldMutationVariables = {
          input: createFieldInput,
        };
        const createFieldResult = await client.graphql<
          GraphQLQuery<CreateTemplateFieldMutation>
        >({ query: createTemplateField, variables: createFieldVars });
        console.log(createFieldResult);
      } catch (err) {
        console.log("error creating template field:", err);
      }
      setIsLoading(false);
      fetchTemplate(template.id);
      closeAndResetModal();
    } catch (err) {
      console.log("error creating sub section:", err);
      setIsLoading(false);
    }
  };

  const closeAndResetModal = () => {
    setModalOpened(false);
    setErrorMsg("");
    setFieldName("");
    setFieldValue("");
  };

  return (
    <Modal opened={modalOpened} onClose={closeAndResetModal} title="Add field">
      <TextInput
        label="Name"
        placeholder="Weight"
        value={fieldName}
        onChange={(event) => setFieldName(event.target.value)}
        required
      />
      <Flex flex={1} align={"center"} justify={"space-between"}>
        <Text>Default value</Text>
        <Button variant="transparent" p={0} onClick={handleInsertInput}>
          Insert input
        </Button>
      </Flex>
      <Textarea
        label=""
        ref={defaultValueRef}
        placeholder={TEMPLATE_SECTION_FIELD_PLACEHOLDER}
        value={fieldValue}
        minRows={4}
        onChange={(event) => setFieldValue(event.target.value)}
        autosize
        resize="vertical"
      />
      {errorMsg && (
        <Text fz={14} fw={400} c={"red"}>
          {errorMsg}
        </Text>
      )}
      <Select
        placeholder="Select section"
        label="Section"
        data={sections}
        value={sectionId}
        onChange={(_value, option) => setSectionId(option.value)}
      />
      <Select
        placeholder="Select subsection"
        label="Subsection"
        data={subSections}
        value={subSectionId}
        onChange={(_value, option) => setSubSectionId(option.value)}
      />
      <Group mt="md">
        <Group mt="md">
          <Button loading={isLoading} onClick={handleAddField}>
            Save
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};

export default AddFieldTemplateModal;
